var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loadComplete)?_c('div',{staticClass:"drill"},_vm._l((_vm.drillModulesByCode),function(drillModule){return _c(drillModule,{ref:drillModule,refInFor:true,tag:"component"})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }